import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { mockGameHistory, mockNotifications } from '../../mocks/user';
import { useEffect, useState } from 'react';

export default function Dashboard() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    if (!user) {
      navigate('/login');
    }
  }, [user, navigate]);

  if (!user) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#0D0E11] via-[#111319] to-[#16181D]">
      {/* Header */}
      <header className="bg-[#1a1c24] border-b border-[#FFD349]/20 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            {/* Logo & Mobile Balance */}
            <div className="flex flex-col gap-2">
              <Link to="/" className="flex items-center gap-3">
                <h1 className="flex items-center gap-2">
                  <div className="relative w-10 h-10 flex items-center justify-center">
                    <img
                      src="https://public.readdy.ai/ai/img_res/aa29cde3-a1c3-46be-b8a4-d1063c9a3299.jpg"
                      alt="DIGITWISE Logo"
                      className="w-full h-full object-contain drop-shadow-[0_0_8px_rgba(239,191,101,0.4)]"
                    />
                  </div>
                  <span className="text-3xl font-bold bg-gradient-to-r from-[#FFD349] via-[#FFC107] to-[#FF9800] bg-clip-text text-transparent" style={{
                    fontFamily: 'Orbitron, sans-serif'
                  }}>
                    DIGITWISE
                  </span>
                </h1>
              </Link>

              {/* Mobile Balance - Below Logo */}
              {user && (
                <div className="md:hidden flex items-center justify-center gap-1 bg-[#0D0E11] border border-[#FFD349]/20 rounded px-3 py-1.5 mx-auto w-fit">
                  <i className="ri-wallet-3-line text-[#FFD349] text-sm"></i>
                  <span className="text-white font-semibold text-sm" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    ${user.balance.toLocaleString()}
                  </span>
                </div>
              )}
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center gap-6">
              <Link to="/" className="text-white/80 hover:text-[#FFD349] transition-colors text-sm font-medium" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                Home
              </Link>
              <Link to="/dashboard" className="text-[#FFD349] text-sm font-medium" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                Dashboard
              </Link>
              <Link to="/wallet" className="text-white/80 hover:text-[#FFD349] transition-colors text-sm font-medium" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                Wallet
              </Link>
              <Link to="/profile" className="text-white/80 hover:text-[#FFD349] transition-colors text-sm font-medium" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                Profile
              </Link>
            </nav>

            {/* Desktop Balance & Logout */}
            <div className="hidden md:flex items-center gap-4">
              <div className="flex items-center gap-3 bg-[#0D0E11] border border-[#FFD349]/30 rounded-lg px-4 py-2">
                <i className="ri-wallet-3-line text-[#FFD349] text-lg"></i>
                <div>
                  <p className="text-white/60 text-xs" style={{ fontFamily: 'Montserrat, sans-serif' }}>Balance</p>
                  <p className="text-[#FFD349] font-bold text-lg" style={{ fontFamily: 'Orbitron, sans-serif' }}>
                    ${user?.balance.toLocaleString() || '0'}
                  </p>
                </div>
              </div>
              <button
                onClick={logout}
                className="bg-gradient-to-r from-[#FFD349] to-[#FFC107] text-black px-6 py-2 rounded-lg font-bold text-sm hover:shadow-[0px_0px_20px_rgba(255,211,73,0.6)] transition-all whitespace-nowrap cursor-pointer"
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              >
                Logout
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden text-white p-2 hover:text-[#FFD349] transition-colors cursor-pointer"
            >
              <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="md:hidden mt-4 pt-4 border-t border-[#FFD349]/20">
              <nav className="flex flex-col gap-3">
                <Link
                  to="/"
                  onClick={() => setMobileMenuOpen(false)}
                  className="text-white/80 hover:text-[#FFD349] transition-colors text-sm font-medium py-2 px-4 rounded-lg hover:bg-[#0D0E11] cursor-pointer"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  <i className="ri-home-line mr-2"></i>
                  Home
                </Link>
                <Link
                  to="/promotions"
                  onClick={() => setMobileMenuOpen(false)}
                  className="text-white/80 hover:text-[#FFD349] transition-colors text-sm font-medium py-2 px-4 rounded-lg hover:bg-[#0D0E11] cursor-pointer"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  <i className="ri-gift-line mr-2"></i>
                  Promotions
                </Link>
                <Link
                  to="/wallet"
                  onClick={() => setMobileMenuOpen(false)}
                  className="text-white/80 hover:text-[#FFD349] transition-colors text-sm font-medium py-2 px-4 rounded-lg hover:bg-[#0D0E11] cursor-pointer"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  <i className="ri-wallet-3-line mr-2"></i>
                  Wallet
                </Link>
                <Link
                  to="/dashboard"
                  onClick={() => setMobileMenuOpen(false)}
                  className="text-[#FFD349] text-sm font-medium py-2 px-4 rounded-lg bg-[#0D0E11] cursor-pointer"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  <i className="ri-dashboard-line mr-2"></i>
                  Dashboard
                </Link>
                <Link
                  to="/profile"
                  onClick={() => setMobileMenuOpen(false)}
                  className="text-white/80 hover:text-[#FFD349] transition-colors text-sm font-medium py-2 px-4 rounded-lg hover:bg-[#0D0E11] cursor-pointer"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  <i className="ri-user-line mr-2"></i>
                  Profile
                </Link>
                <Link
                  to="/support"
                  onClick={() => setMobileMenuOpen(false)}
                  className="text-white/80 hover:text-[#FFD349] transition-colors text-sm font-medium py-2 px-4 rounded-lg hover:bg-[#0D0E11] cursor-pointer"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  <i className="ri-customer-service-2-line mr-2"></i>
                  Support
                </Link>
                <button
                  onClick={() => {
                    setMobileMenuOpen(false);
                    logout();
                  }}
                  className="text-white/80 hover:text-[#FFD349] transition-colors text-sm font-medium py-2 px-4 rounded-lg hover:bg-[#0D0E11] text-left cursor-pointer"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  <i className="ri-logout-box-line mr-2"></i>
                  Logout
                </button>
              </nav>
            </div>
          )}
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 py-6 md:py-8">
        {/* User Info Header */}
        <div className="bg-gradient-to-r from-[#FFD349] to-[#FFC107] rounded-xl p-4 md:p-6 mb-6 md:mb-8 shadow-[0px_0px_30px_rgba(255,211,73,0.3)]">
          <div className="flex flex-col md:flex-row items-center md:justify-between gap-4">
            <div className="flex flex-col md:flex-row items-center gap-4 w-full md:w-auto">
              <div className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center bg-[#0D0E11] rounded-full border-4 border-white/20">
                <span className="text-[#FFD349] text-2xl md:text-3xl font-bold" style={{ fontFamily: 'Orbitron, sans-serif' }}>
                  {user.username.charAt(0)}
                </span>
              </div>
              <div className="text-center md:text-left">
                <h1 className="text-2xl md:text-3xl font-bold text-black mb-1" style={{ fontFamily: 'Orbitron, sans-serif' }}>
                  {user.username}
                </h1>
                {/* <p className="text-black/70 text-xs md:text-sm mb-2" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  {user.email}
                </p>
                <div className="flex items-center justify-center md:justify-start gap-2">
                  <span className="bg-black/20 px-3 py-1 rounded-full text-xs font-semibold text-black whitespace-nowrap" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    {user.vipLevel} VIP
                  </span>
                  {user.verified && (
                    <span className="bg-green-500 px-3 py-1 rounded-full text-xs font-semibold text-white flex items-center gap-1 whitespace-nowrap" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                      <i className="ri-verified-badge-fill"></i>
                      Verified
                    </span>
                  )}
                </div> */}
              </div>
            </div>
            <div className="text-center md:text-right">
              <p className="text-xs md:text-sm text-black/70 mb-1" style={{ fontFamily: 'Montserrat, sans-serif' }}>Total Balance</p>
              <p className="text-3xl md:text-4xl font-black text-black" style={{ fontFamily: 'Orbitron, sans-serif' }}>
                ${user.balance.toLocaleString()}
              </p>
              {/* <p className="text-xs md:text-sm text-black/70" style={{ fontFamily: 'Montserrat, sans-serif' }}>{user.currency}</p> */}
            </div>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-6 mb-6 md:mb-8">
          <div className="bg-[#1a1c24] border border-[#FFD349]/20 rounded-xl p-4 md:p-6 hover:border-[#FFD349]/40 transition-all">
            <div className="flex flex-col md:flex-row items-center md:justify-between mb-3 gap-2">
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-gradient-to-r from-[#FFD349] to-[#FFC107] rounded-lg">
                <i className="ri-trophy-fill text-xl md:text-2xl text-black"></i>
              </div>
              <span className="text-xs text-white/60 whitespace-nowrap text-center md:text-right" style={{ fontFamily: 'Montserrat, sans-serif' }}>Total Wagered</span>
            </div>
            {/* <p className="text-lg md:text-2xl font-bold text-white mb-1 text-center md:text-left" style={{ fontFamily: 'Orbitron, sans-serif' }}>
              ${user.totalWagered.toLocaleString()}
            </p>
            <p className="text-xs text-white/60 text-center md:text-left" style={{ fontFamily: 'Montserrat, sans-serif' }}>{user.currency}</p> */}
          </div>

          <div className="bg-[#1a1c24] border border-[#FFD349]/20 rounded-xl p-4 md:p-6 hover:border-[#FFD349]/40 transition-all">
            <div className="flex flex-col md:flex-row items-center md:justify-between mb-3 gap-2">
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-gradient-to-r from-green-400 to-green-500 rounded-lg">
                <i className="ri-money-dollar-circle-fill text-xl md:text-2xl text-white"></i>
              </div>
              <span className="text-xs text-white/60 whitespace-nowrap text-center md:text-right" style={{ fontFamily: 'Montserrat, sans-serif' }}>Total Won</span>
            </div>
            {/* <p className="text-lg md:text-2xl font-bold text-white mb-1 text-center md:text-left" style={{ fontFamily: 'Orbitron, sans-serif' }}>
              ${user.totalWon.toLocaleString()}
            </p>
            <p className="text-xs text-white/60 text-center md:text-left" style={{ fontFamily: 'Montserrat, sans-serif' }}>{user.currency}</p> */}
          </div>

          <div className="bg-[#1a1c24] border border-[#FFD349]/20 rounded-xl p-4 md:p-6 hover:border-[#FFD349]/40 transition-all">
            <div className="flex flex-col md:flex-row items-center md:justify-between mb-3 gap-2">
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-gradient-to-r from-purple-400 to-purple-500 rounded-lg">
                <i className="ri-gamepad-fill text-xl md:text-2xl text-white"></i>
              </div>
              <span className="text-xs text-white/60 whitespace-nowrap text-center md:text-right" style={{ fontFamily: 'Montserrat, sans-serif' }}>Games Played</span>
            </div>
            {/* <p className="text-lg md:text-2xl font-bold text-white mb-1 text-center md:text-left" style={{ fontFamily: 'Orbitron, sans-serif' }}>
              {user.gamesPlayed.toLocaleString()}
            </p> */}
            <p className="text-xs text-white/60 text-center md:text-left" style={{ fontFamily: 'Montserrat, sans-serif' }}>Games</p>
          </div>

          <div className="bg-[#1a1c24] border border-[#FFD349]/20 rounded-xl p-4 md:p-6 hover:border-[#FFD349]/40 transition-all">
            <div className="flex flex-col md:flex-row items-center md:justify-between mb-3 gap-2">
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-gradient-to-r from-blue-400 to-blue-500 rounded-lg">
                <i className="ri-line-chart-fill text-xl md:text-2xl text-white"></i>
              </div>
              <span className="text-xs text-white/60 whitespace-nowrap text-center md:text-right" style={{ fontFamily: 'Montserrat, sans-serif' }}>Win Rate</span>
            </div>
            {/* <p className="text-lg md:text-2xl font-bold text-white mb-1 text-center md:text-left" style={{ fontFamily: 'Orbitron, sans-serif' }}>
              {((user.totalWon / user.totalWagered) * 100).toFixed(1)}%
            </p> */}
            <p className="text-xs text-white/60 text-center md:text-left" style={{ fontFamily: 'Montserrat, sans-serif' }}>Average</p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
          {/* Recent Game History */}
          <div className="lg:col-span-2">
            <div className="bg-[#1a1c24] border border-[#FFD349]/20 rounded-xl p-4 md:p-6">
              <div className="flex items-center justify-between mb-4 md:mb-6">
                <h2 className="text-lg md:text-xl font-bold text-white" style={{ fontFamily: 'Orbitron, sans-serif' }}>
                  Recent Game History
                </h2>
                <Link to="/game-lobby" className="text-[#FFD349] hover:text-[#FFC107] text-xs md:text-sm transition-colors whitespace-nowrap cursor-pointer" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  View All →
                </Link>
              </div>
              <div className="space-y-3 md:space-y-4">
                {mockGameHistory.map((game) => (
                  <div
                    key={game.id}
                    className="flex items-center justify-between p-3 md:p-4 bg-[#0D0E11] border border-[#FFD349]/10 rounded-lg hover:border-[#FFD349]/30 transition-all"
                  >
                    <div className="flex items-center gap-3 md:gap-4">
                      <div className={`w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg ${game.result === 'win'
                        ? 'bg-gradient-to-r from-green-400/20 to-green-500/20 border border-green-400/30'
                        : 'bg-gradient-to-r from-red-400/20 to-red-500/20 border border-red-400/30'
                        }`}>
                        <i className={`${game.result === 'win' ? 'ri-arrow-up-line text-green-400' : 'ri-arrow-down-line text-red-400'
                          } text-xl md:text-2xl`}></i>
                      </div>
                      <div>
                        <p className="text-white font-semibold text-xs md:text-sm" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                          {game.gameName}
                        </p>
                        <p className="text-white/60 text-xs" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                          {game.provider}
                        </p>
                      </div>
                    </div>
                    <div className="text-right">
                      {/* <p className={`font-bold text-xs md:text-sm ${
                        game.profit > 0 ? 'text-green-400' : 'text-red-400'
                      }`} style={{ fontFamily: 'Orbitron, sans-serif' }}>
                        {game.profit > 0 ? '+' : ''}{game.profit.toLocaleString()} {user.currency}
                      </p> */}
                      <p className="text-white/60 text-xs" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                        Bet: {game.betAmount.toLocaleString()}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Notifications & Quick Actions */}
          <div className="space-y-6">
            {/* Notifications */}
            <div className="bg-[#1a1c24] border border-[#FFD349]/20 rounded-xl p-4 md:p-6">
              <h2 className="text-lg md:text-xl font-bold text-white mb-4 md:mb-6" style={{ fontFamily: 'Orbitron, sans-serif' }}>
                Notifications
              </h2>
              <div className="space-y-3 md:space-y-4">
                {mockNotifications.map((notif) => (
                  <div
                    key={notif.id}
                    className={`p-3 md:p-4 rounded-lg transition-all ${notif.read
                      ? 'bg-[#0D0E11] border border-[#FFD349]/10'
                      : 'bg-gradient-to-r from-[#FFD349]/10 to-[#FFC107]/10 border border-[#FFD349]/30'
                      }`}
                  >
                    <div className="flex items-start gap-3">
                      <div className={`w-8 h-8 flex items-center justify-center rounded-lg ${notif.type === 'bonus' ? 'bg-[#FFD349]/20' :
                        notif.type === 'withdrawal' ? 'bg-green-400/20' :
                          'bg-purple-400/20'
                        }`}>
                        <i className={`${notif.type === 'bonus' ? 'ri-gift-fill text-[#FFD349]' :
                          notif.type === 'withdrawal' ? 'ri-bank-card-fill text-green-400' :
                            'ri-vip-crown-fill text-purple-400'
                          } text-base md:text-lg`}></i>
                      </div>
                      <div className="flex-1">
                        <p className="text-white font-semibold text-xs md:text-sm mb-1" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                          {notif.title}
                        </p>
                        <p className="text-white/60 text-xs" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                          {notif.message}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Quick Actions */}
            <div className="bg-[#1a1c24] border border-[#FFD349]/20 rounded-xl p-4 md:p-6">
              <h2 className="text-lg md:text-xl font-bold text-white mb-4" style={{ fontFamily: 'Orbitron, sans-serif' }}>
                Quick Actions
              </h2>
              <div className="space-y-3">
                <Link
                  to="/wallet"
                  className="flex items-center justify-between p-3 md:p-4 bg-gradient-to-r from-green-400/10 to-green-500/10 border border-green-400/30 rounded-lg hover:border-green-400/50 transition-all cursor-pointer group"
                >
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center bg-green-400/20 rounded-lg group-hover:bg-green-400/30 transition-all">
                      <i className="ri-add-circle-fill text-green-400 text-xl"></i>
                    </div>
                    <span className="text-white font-semibold text-sm whitespace-nowrap" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                      Deposit
                    </span>
                  </div>
                  <i className="ri-arrow-right-s-line text-white group-hover:text-green-400 transition-colors"></i>
                </Link>
                <Link
                  to="/wallet"
                  className="flex items-center justify-between p-3 md:p-4 bg-gradient-to-r from-blue-400/10 to-blue-500/10 border border-blue-400/30 rounded-lg hover:border-blue-400/50 transition-all cursor-pointer group"
                >
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center bg-blue-400/20 rounded-lg group-hover:bg-blue-400/30 transition-all">
                      <i className="ri-subtract-fill text-blue-400 text-xl"></i>
                    </div>
                    <span className="text-white font-semibold text-sm whitespace-nowrap" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                      Withdraw
                    </span>
                  </div>
                  <i className="ri-arrow-right-s-line text-white group-hover:text-blue-400 transition-colors"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
